// pages/TransDataList.js

import Header from "../components/HomeScreen/Header";
import TransactionList from "../components/TransactionScreen/TransactionList"
import Footer from "../components/HomeScreen/Footer";

const TransDataList = () => {
  return (
    <>
      <Header />
      <TransactionList />
      <Footer />
    </>
  );
}
export default TransDataList;
